import { render } from "./iconTable.vue?vue&type=template&id=24398e52"
import script from "./iconTable.vue?vue&type=script&lang=js"
export * from "./iconTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__